export default __webpack_public_path__ + "static/media/rice01.475aaca8.png";